export default __webpack_public_path__ + "static/31-7983d75cd31e9cd06e77d845149cf7cb.jpg";